import { RequestSinacorNoteAction } from './report-sinacor.action';

export interface ReportSinacorState {
    markets: {
        stock: boolean,
        future: boolean
    },
    dateFrom: string,
    dateTo: string,
    requestedNote: boolean,
    pending: boolean
}

export const initialState: ReportSinacorState = {
    markets: {
        stock: false,
        future: false
    },
    dateFrom: '',
    dateTo: '',
    requestedNote: false,
    pending: false
};

export function RequestSinacorNoteReducer(state: ReportSinacorState = initialState, action: RequestSinacorNoteAction) {
    switch (action.type) {
        case RequestSinacorNoteAction.requestSinacorNote:
            return {...state, ...{ pending: true, error: null } };
        case RequestSinacorNoteAction.requestSinacorNoteSuccess:
            return {...state, ...{ pending: false, error: null, requestedNote: true }};
        case RequestSinacorNoteAction.requestSinacorNoteError:
            return {...state, ...{ pending: false } };
        default:
            return state;
    }
}